<div class="page-container">
  <!-- Left Curved Blue Section -->
  <div class="blue-banner">
    <div class="content-wrapper">
      <h1 class="title">
        {{ text.titleLine1 }}<br />
        {{ text.titleLine2 }}
      </h1>

      <p class="description">
        {{ text.description }}
      </p>

      <div class="action-buttons">
        <button class="btn btn-outline" (click)="goBack()">
          {{ text.logoutButton }}
        </button>

        <button class="btn btn-primary" (click)="refreshPage()">
          {{ text.refreshButton }}
        </button>
      </div>
    </div>
  </div>

  <!-- Right Visual Section -->
  <div class="visual-container">
    <div class="illustration-wrapper">
      <!-- Error Exclamation Badge -->
      <div class="badge-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
          stroke-linejoin="round" role="img" aria-label="Error">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <!-- Gear / Technical Error Line Art -->
      <svg class="gear-icon" viewBox="0 0 100 100" fill="none" stroke="#0044cc" stroke-width="3" stroke-linecap="round"
        stroke-linejoin="round" aria-hidden="true">
        <!-- Main Broken Gear -->
        <path d="M50 20 A30 30 0 1 1 20 50 L30 50 A20 20 0 1 0 50 30 Z" />
        <path d="M48 10 L52 10 M50 8 L50 12" />
        <path d="M78 22 L82 18" />
        <path d="M90 50 L95 50" />
        <path d="M78 78 L82 82" />
        <path d="M50 90 L50 95" />
        <!-- Secondary Gear -->
        <circle cx="75" cy="70" r="12" stroke-dasharray="4 2" />
        <!-- Broken Spark Lines -->
        <path d="M25 25 L18 18 M32 18 L28 10" stroke="#0044cc" stroke-width="2.5" />
      </svg>
    </div>

    <!-- Error Code Footer Tag -->
    <div class="error-meta" aria-label="Error Code ERR_RENDER_503, Trace ID 8f92a40c">
      Error Code: <span>ERR_RENDER_503</span> | Trace ID: <span>#8f92a40c</span>
    </div>
  </div>
</div>